import pdf from '../../assets/images/icons/pdf-icon.png';

export const getMimeTypeHelper = (extension?: string) => {
    const mimeTypes: {[key: string]: string} = {
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        pdf: 'application/pdf',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    };
    return mimeTypes[extension || ''] || 'application/octet-stream';
};

export const getFileIconHelper = (extension?: string) => {
    const fileIcons: {[key: string]: string} = {
        pdf: pdf,
        doc: pdf,
        docx: pdf,
        xls: '/assets/icons/excel-icon.png',
        xlsx: '/assets/icons/excel-icon.png',
    };
    return fileIcons[extension || ''] || pdf;
};
